module.exports = __webpack_public_path__ + "static/media/colorBlue.2b6f4df9.png";